import React from 'react';
import PropTypes from 'prop-types';

import DisplayComponent from '../BaseComponents/DisplayComponent';

import './Spinner.module.css';

const Spinner = ({ color, size }) => (
  <div styleName="spinner" style={{ fontSize: size, color }} />
);

Spinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

Spinner.defaultProps = {
  color: '#000',
  size: 10
};

export default DisplayComponent(Spinner);
